import { render, staticRenderFns } from "./InnerChatsList.vue?vue&type=template&id=aa00896e&scoped=true&"
import script from "./InnerChatsList.vue?vue&type=script&lang=ts&"
export * from "./InnerChatsList.vue?vue&type=script&lang=ts&"
import style0 from "./InnerChatsList.vue?vue&type=style&index=0&id=aa00896e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa00896e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VImg,VList,VToolbar})
